export default __webpack_public_path__ + "static/media/cv.42dfff6b.png";